import './payment.css';

import paypal from '../../../assets/images/paypal.png';
import mercado_pago from '../../../assets/images/mp_logo.png';
import visa_master from '../../../assets/images/Visa-MasterCard.png';
import logo_openpay from '../../../assets/images/logotipo_openpay.jpg';

import {
    Grid, Radio, Box, Accordion, AccordionSummary, Typography
} from "@mui/material";

const PaymentMethods = ({ activeMethod, setActiveMethod }) => {

    const handleChange = (panel) => (event, newExpanded) => {
        setActiveMethod(newExpanded ? panel : '');
    };

    return (
        <>
            {/* Mercadopago */}
            <Accordion
                expanded={activeMethod === "MercadoPago"}
                onChange={handleChange("MercadoPago")}
                sx={{
                    '&.Mui-expanded': {
                        boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)'
                    },
                }}
            >
                <AccordionSummary
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Grid container wrap="wrap">
                        <Grid item md={9} xs>
                            <Box display="flex" alignItems="center">
                                <Radio checked={activeMethod === "MercadoPago"} />
                                <Box>
                                    <Typography variant="subtitle1">Mercado pago</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Tarjeta de crédito, débito y Efectivo
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item md={3} xs sx={{ my: 'auto' }}>
                            <Box display="flex" flexDirection="row-reverse" alignItems="center">
                                <img
                                    className="pm_style_1"
                                    src={mercado_pago}
                                    width="180%"
                                    alt="mercadopago_logo"
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </AccordionSummary>
            </Accordion>
            {/* Fin Mercadopago */}

            {/* Paypal */}
            <Accordion
                expanded={activeMethod === "PayPal"}
                onChange={handleChange("PayPal")}
                sx={{
                    '&.Mui-expanded': {
                        boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)'
                    },
                }}
            >
                <AccordionSummary
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <Grid container wrap="wrap">
                        <Grid item md={9} xs>
                            <Box display="flex" alignItems="center">
                                <Radio checked={activeMethod === "PayPal"} />
                                <Typography variant="subtitle1">PayPal</Typography>
                            </Box>
                        </Grid>
                        <Grid item md={3} xs sx={{ my: 'auto' }}>
                            <Box display="flex" flexDirection="row-reverse" alignItems="center">
                                <img
                                    className="pm_style_2"
                                    src={paypal}
                                    width="80%"
                                    alt="paypal_logo"
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </AccordionSummary>
            </Accordion>
            {/* Fin paypal */}

            {/* Pago con tarjeta de crédito o débito (OpenPay) */}
            <Accordion
                expanded={activeMethod === "OpenPay"}
                onChange={handleChange("OpenPay")}
                sx={{
                    '&.Mui-expanded': {
                        margin: '16px 0 0 0',
                        boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)'
                    },
                }}
            >
                <AccordionSummary
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                >
                    <Grid container wrap="wrap">
                        <Grid item md={9} xs>
                            <Box display="flex" alignItems="center">
                                <Radio checked={activeMethod === "OpenPay"} />
                                <Box>
                                    <Typography variant="subtitle1">OpenPay BBVA</Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Tarjeta de crédito / débito
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item md={3} xs sx={{ my: 'auto' }}>
                            <Box display="flex" flexDirection="row-reverse" alignItems="center">
                                <img
                                    className="pm_style_2"
                                    src={logo_openpay}
                                    width="70%"
                                    alt="visa-mastercard-american"
                                />
                                <img
                                    className="pm_style_2"
                                    src={visa_master}
                                    width="70%"
                                    alt="visa-mastercard-american"
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </AccordionSummary>
            </Accordion>
            {/* Fin tarjeta de débito o crédito (OpenPay) */}
        </>
    );
};

export default PaymentMethods;
